import { Route, Switch } from 'react-router-dom';
import Navigation from './Navigation';
import SalesforceExperts from '../pages/Experts';
import SFCourses from "../pages/SFCourses";
import SFTestimonials from '../pages/SFTestimonials';
import SFCalendar from '../pages/SFCalendar'

const Routing = () => {
  return (      
    <Switch >
        <Route exact path="/Salesforce/Courses">
            <Navigation />            
            <SFCourses />
        </Route>
        <Route exact path="/Salesforce/LearningPaths">
            <Navigation />            
            <h1>Learning Paths</h1>
        </Route>   
        <Route exact path="/Salesforce/Testimonials">
            <Navigation />            
            <SFTestimonials />
        </Route> 
        <Route exact path="/Salesforce/LkmExperts">
            <Navigation />            
            <SalesforceExperts/>
        </Route>
        {/* <Route exact path="/Salesforce/calendar">
            <Navigation />            
            <SFCalendar />
        </Route>   */}
    </Switch>                     
  )
}

export default Routing;